import axios from "axios";

export async function getUserinfo() {
  return axios.get("/api/profile/userinfo");
}

export async function validateInvitation({ code, identifier }) {
  const { data } = await axios.get("/api/business/v1/invites/validate", {
    params: { code, identifier },
  });
  return data;
}

export async function submitInvitationToMarilyn({ code, phone, email }) {
  return axios.patch("/api/business/v1/invites/process", {
    code,
    phone: phone || null,
    ...(email !== undefined && { email: email || null }),
    status: "accepted",
  });
}

export async function submitInvitationToMoT({ code }) {
  return axios.post(`/api/mot_auth/invitation/${code}`);
}
